class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.showClass = 'show';
    }

    connectedCallback() {
        const mainCTA = document.querySelector('.quantity-submit-row__submit');
        if (!mainCTA) return;

        document.addEventListener("DOMContentLoaded", (e) => {
            this.form = this.querySelector(".sticky-form");

            if (this.form) {
                if (theme.settings.afterAddToCart !== 'no-js') {
                    this.submitBtn = this.querySelector('.sticky-add-to-cart-btn');
                    this.form.addEventListener('submit', this.handleSubmit.bind(this));
                }
            }
        })

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const isMobile = window.matchMedia("(max-width: 1024px)").matches;

                    if (entry.isIntersecting) {
                        this.classList.remove(this.showClass);
                    } else {
                        if (isMobile) {
                            const rect = mainCTA.getBoundingClientRect();
                            const scrolledPast = rect.top < 0;
                            if (scrolledPast) {
                                this.classList.add(this.showClass);
                            } else {
                                this.classList.remove(this.showClass);
                            }
                        } else {
                            this.classList.add(this.showClass);
                        }
                    }
                });
            },
            { threshold: 0 }
        );

        observer.observe(mainCTA);
    }

    async handleSubmit(evt) {
        evt.preventDefault();
        this.submitBtn.classList.add('is-loading');

        const formData = new FormData(this.form);
        const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el);
        const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sectionIds.join(','));

        const fetchRequestOpts = {
            method: 'POST',
            headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        };

        try {
            const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
            const data = await response.json();

            if (!response.ok) throw new Error(response.status);

            if (document.querySelector('.template-cart')) {
                // Cart page
                const cartForm = document.querySelector('cart-form');
                if (cartForm && cartForm.enableAjaxUpdate) {
                    cartForm.refresh();
                }
            } else if (theme.settings.afterAddToCart === 'page') {
                // Allow the tick animation to complete
                setTimeout(() => {
                    window.location.href = theme.routes.cart;
                }, 300);
            } else {
                sectionsToUpdate.forEach((el) => {
                    el.updateFromCartChange(data.sections[el.dataset.sectionId]);
                });

                if (theme.settings.afterAddToCart === 'notification') {
                    const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
                    notification.dataset.productTitle = data.product_title;
                    let notificationContainer = document.querySelector('.pageheader--sticky');
                    if (!notificationContainer) {
                        notificationContainer = document.querySelector('body');
                    }
                    notificationContainer.appendChild(notification);
                } else if (theme.settings.afterAddToCart === 'drawer') {
                    document.querySelector('.js-cart-drawer').open();
                }
            }

            this.dispatchEvent(new CustomEvent('on:cart:add', {
                bubbles: true,
                detail: {
                    variantId: data.variant_id
                }
            }));

            this.submitBtn.classList.add('is-success');
            setTimeout(() => {
                this.submitBtn.classList.remove('is-loading');
                this.submitBtn.classList.remove('is-success');
            }, 2000);
        } catch (error) {
            console.log(error);
            this.dispatchEvent(new CustomEvent('on:cart:error', {
                bubbles: true,
                detail: {
                    error: this.errorMsg.textContent
                }
            }));

            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.classList.remove('is-success');
        }
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);